<ng-container *ngIf="product$ | async as product">
  <app-custom-product-labels-items-view
    [labels]="product.labelProduct">
  </app-custom-product-labels-items-view>
</ng-container>
